import { Interpolation, Theme } from '@emotion/react'
import styled from '@emotion/styled'
import { forwardRef, memo, useEffect, useState } from 'react'
import i18n from '../../utilities/i18n'
import { InlineDotLoading } from '../presentation/InlineLoading'
import Link from '../presentation/Link'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'

const LoadingOuterRoot = styled('div')({
    display: 'flex',
    width: '100%',
    height: '100%',
    flex: 'auto',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
})

const LoadingInnerRoot = styled('div')({
    flex: 'none',
    color: palette.contrastIcons,
    padding: getThemeSpacing(3),
    fontSize: '1.1607142857142858rem',
    fontWeight: 600,
})

const LoadingNote = styled('div')({
    fontSize: '0.7rem',
    color: palette.secondaryText,
})

/**
 * TODO: Revert showReloadNotice once loading issue is fixed
 */
interface LoadingDataProps {
    rootOuterStyleOverrides?: Interpolation<Theme>
    rootInnerStyleOverrides?: Interpolation<Theme>
    noteOuterStyleOverrides?: Interpolation<Theme>
    noteInnerStyleOverrides?: Interpolation<Theme>
    loadingStyleOverrides?: Interpolation<Theme>
    showReloadNotice?: boolean
    active?: boolean
    note?: string
    text?: string
}

/**
 * TODO: Revert showReloadNotice and related state/useEffect when loading issue is fixed
 */
export const LoadingData = memo(
    forwardRef(
        (
            {
                rootOuterStyleOverrides,
                rootInnerStyleOverrides,
                noteOuterStyleOverrides,
                noteInnerStyleOverrides,
                loadingStyleOverrides,
                text = 'LOADING...',
                showReloadNotice,
                active,
                note,
            }: LoadingDataProps = {},
            ref,
        ) => {
            const [showReload, setShowRelaod] = useState(false)

            useEffect(() => {
                if (!showReloadNotice || showReload) return
                setInterval(() => {
                    setShowRelaod(true)
                }, 15000)
            }, [showReload])

            return (
                <LoadingOuterRoot
                    css={rootOuterStyleOverrides}
                    ref={ref as React.RefObject<HTMLDivElement>}
                >
                    <LoadingInnerRoot css={rootInnerStyleOverrides}>
                        {!!text && <div>{text}</div>}
                        {!!note && (
                            <LoadingNote css={noteOuterStyleOverrides}>
                                <div css={noteInnerStyleOverrides}>{note}</div>
                            </LoadingNote>
                        )}
                        <InlineDotLoading
                            styleOverrides={loadingStyleOverrides}
                            active={active ?? false}
                        />
                        {!!showReload && showReloadNotice && (
                            <div>
                                <br />
                                {i18n.t('system.loadingNotice')}
                                <br />
                                <Link
                                    mfc
                                    actionLink
                                    onClick={() => {
                                        window.location.reload()
                                    }}
                                >
                                    {i18n.t('system.clickHereToReload')}
                                </Link>
                            </div>
                        )}
                    </LoadingInnerRoot>
                </LoadingOuterRoot>
            )
        },
    ),
)
